import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { State, City, ViaCep } from '../model/application';
import { InterceptorSkipDealerIdHeader, InterceptorSkipHeader, InterceptorSkipOemDealerIdHeader } from '../guards/skip.interceptor';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {
  constructor(private http: HttpClient) { }

  getEstados(): Observable<State[]> {
    return this.http.get('./assets/json/estados.json').pipe(
      take(1),
      map((response: State[]) => {
        return response;
      })
    );
  }

  getCidades(sigla: string): Observable<City[]> {
    return this.http.get('./assets/json/cidades-todas.json').pipe(
      take(1),
      map((response: City[]) => {
        return response[sigla];
      })
    );
  }

  getCep(cep: string): Observable<ViaCep> {
    const cleanCep = cep?.replace(/\D/g, '') || '';

    if (cleanCep.length < 8) {
      return;
    }
    return this.http
      .get(`https://viacep.com.br/ws/${cleanCep}/json/`, {
        headers: new HttpHeaders()
          .set(InterceptorSkipHeader, '')
          .set(InterceptorSkipOemDealerIdHeader, '')
          .set(InterceptorSkipDealerIdHeader, '')
      })
      .pipe(
        take(1),
        map((response: ViaCep) => response)
      );
  }

  getCepByCreateDealer(cep: string): Observable<ViaCep> {
    return this.http
      .get(`https://viacep.com.br/ws/${cep}/json/`)
      .pipe(
        take(1),
        map((response: ViaCep) => response)
      );
  }
}
